import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { vehicleFocusAtom } from '../../../../OnlineMapNew/OnlineMapState';

export default function VehicleFocus(): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [vehicleFocus, setVehicleFocus] = useRecoilState<boolean>(vehicleFocusAtom);

  const handleChangeVehicleFocus = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    setVehicleFocus(!vehicleFocus);
  };

  return (
    <a
      onClick={handleChangeVehicleFocus}
      title={f({ id: 'map.focusontarget' })}
      data-cy="controls-on-graph-map-focusontarget"
      className={`${vehicleFocus ? 'e-button-sq text-primary' : 'e-button-sq'}`}
    >
      <i className="cmd-icon cmd-icon-zoom-out-map" />
    </a>
  );
}
